import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Inline, CircleIcon } from './DotsBreadCrumb.Styles'
import { colors } from '../../constants'

class DotsBreadCrumb extends PureComponent {
    static propTypes = {
        dotsNumber: PropTypes.number.isRequired,
        actualDotNumber: PropTypes.number,
        margin: PropTypes.string,
    }

    static defaultProps = {
        actualDotNumber: 0,
        margin: null,
    }

    hexToRGB = (color) => {
        let hex = color.replace('#', '')
        const r = parseInt(hex.substring(0, 2), 16)
        hex = hex.slice(2)
        const g = parseInt(hex.substring(0, 2), 16)
        hex = hex.slice(2)
        const b = parseInt(hex.substring(0, 2), 16)
        const rgb = [r, g, b]
        return rgb
    }

    interpolateColor = (color1, color2, factor = 0.5) => {
        const result = color1.slice()
        for (let i = 0; i < 3; i += 1) {
            result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]))
        }
        return {
            r: result[0],
            g: result[1],
            b: result[2],
        }
    }

    interpolateColors = (color1, color2, steps) => {
        const stepFactor = 1 / (steps - 1)
        const interpolatedColorArray = []

        for (let i = 0; i < steps; i += 1) {
            interpolatedColorArray.push(this.interpolateColor(color1, color2, stepFactor * i))
        }

        return interpolatedColorArray
    }

    rgbToHex = (color) => {
        let hex = '#'
        hex += this.addZeroBefore(color.r.toString(16))
        hex += this.addZeroBefore(color.g.toString(16))
        hex += this.addZeroBefore(color.b.toString(16))
        return hex
    }

    addZeroBefore = (s) => {
        if (s.length === 0) return '00'
        if (s.length < 2) return `0${s}`
        return s
    }

    renderDots = () => {
        const { dotsNumber, actualDotNumber } = this.props

        const dots = []

        const dark = this.hexToRGB(colors.greydark)
        const light = this.hexToRGB(colors.grey)
        const interpolatedColors = this.interpolateColors(light, dark, actualDotNumber > dotsNumber ? dotsNumber : actualDotNumber + 1)

        for (let i = 1; i <= dotsNumber; i += 1) {
            dots.push(
                <Inline first={i === 1}>
                    <CircleIcon icon="circle" size="xs" color={i <= actualDotNumber ? this.rgbToHex(interpolatedColors[i]) : null} />
                </Inline>
            )
        }
        return dots
    }

    render() {
        const { margin } = this.props
        return <div style={{ margin }}>{this.renderDots()}</div>
    }
}

export default withTranslation()(DotsBreadCrumb)
